import React from 'react'
import { Row } from 'antd'
import { options } from './options'
import { useTranslation } from 'next-i18next'
import { CustomCol, CustomTitle } from 'src/components'

const WithdrawalsListHeader: React.FC<{ quantity: number }> = ({ quantity }) => {
  const { t } = useTranslation()

  return <Row>
    {/* Title */}
    <CustomCol lg={12}>
      <CustomTitle label={`${t('general.ResultsLength', { length: quantity })}`} type={null} />
    </CustomCol>

    {/* Status */}
    <CustomCol lg={4}>
      <options.FilterWithdrawalByStatus />
    </CustomCol>

    {/* Text */}
    <CustomCol lg={4}>
      <options.FilterWithdrawalByText />
    </CustomCol>

    {/* Reset */}
    <CustomCol lg={4}>
      <options.WithdrawalFilterResetButton />
    </CustomCol>
  </Row>

}

export default WithdrawalsListHeader
